<template>
  <div>
    <main-layout>
      <AdminMenu />
      <v-container>
        <v-layout wrap class="pt-4">
          <v-flex xs12>
            <h1>Patient</h1>
          </v-flex>
          <v-flex xs12 sm6>
            <v-btn dark depressed color="primary" @click="showAdvancedSearch = !showAdvancedSearch">
              <v-icon>search</v-icon>
              &nbsp;
              {{ $t('advanced search') }}&nbsp;
              <em v-if="!showAdvancedSearch" class="fas fa-angle-down" />
              <em v-else class="fas fa-angle-up" />
            </v-btn>
          </v-flex>
          <v-flex xs12 sm6 class="text-sm-right text-xs-right">
            <v-btn dark outline color="primary" :loading="loading" @click="handleExportXlsx">
              <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
            </v-btn>
          </v-flex>
          <v-flex>
            <div
              v-if="showAdvancedSearch"
              class="mb-4 py-2"
              style="border: 1px solid #eee; border-radius: 10px; position: relative"
            >
              <v-layout wrap class="form-control">
                <v-flex xs3 px-2>
                  <div class="caption">ชื่อจริง</div>
                  <input v-model="filter.first_name" type="text" placeholder="ชื่อจริง" />
                </v-flex>
                <v-flex xs3 px-2>
                  <div class="caption">นามสกุล</div>
                  <input v-model="filter.last_name" type="text" placeholder="นามสกุล" />
                </v-flex>
                <v-flex xs3 px-2>
                  <div class="caption">อายุ</div>
                  <input v-model="filter.age" type="text" placeholder="อายุ" />
                </v-flex>
                <v-flex xs3 px-2>
                  <div class="caption">เพศ</div>
                  <multiselect
                    v-model="filter.gender"
                    :options="genderOptions"
                    label="label"
                    select-label
                    selected-label
                    track-by="value"
                  ></multiselect>
                </v-flex>

                <v-flex xs3 px-2>
                  <div class="caption">วันที่เริ่มต้น</div>
                  <DatepickerCustomDialog v-model="filter.date_from" :allowed-dates="allowedDates">
                    <input
                      type="text"
                      :value="handleGetDateFormatted(filter.date_from)"
                      placeholder="เลือกวันที่เริ่มต้น"
                      readonly
                    />
                  </DatepickerCustomDialog>
                </v-flex>
                <v-flex xs3 px-2>
                  <div class="caption">วันที่สิ้นสุด</div>
                  <DatepickerCustomDialog v-model="filter.date_to" :allowed-dates="allowedDates">
                    <input
                      type="text"
                      :value="handleGetDateFormatted(filter.date_to)"
                      placeholder="เลือกวันที่สิ้นสุด"
                      readonly
                    />
                  </DatepickerCustomDialog>
                </v-flex>
                <v-flex xs3 px-2>
                  <div class="caption">สถานะ</div>
                  <multiselect
                    v-model="filter.status"
                    :options="statusOptions"
                    select-label
                    selected-label
                  ></multiselect>
                </v-flex>
                <v-flex xs12 class="text-xs-right">
                  <v-btn outline color="grey" @click="handleClearSearch">{{
                    $t('Clear Search')
                  }}</v-btn>
                  <v-btn depressed color="primary" @click="handleSearch">
                    <em class="fas fa-search mr-1" />
                    {{ $t('Search') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
        <v-data-table
          hide-actions
          :loading="loading"
          :headers="headers"
          :items="patientListData"
          :pagination.sync="pagination"
          class="elevation-1 mt-3"
        >
          <template slot="headerCell" slot-scope="props">
            <HeaderTableWithSort
              :headers="props.header"
              :sort-by.sync="sortBy"
              :order-by.sync="orderBy"
              @onSort="handleChangeSort"
            ></HeaderTableWithSort>
          </template>
          <template #items="props">
            <tr>
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.first_name || '-' }}</td>
              <td>{{ props.item.last_name || '-' }}</td>
              <td>{{ props.item.age || '-' }}</td>
              <td>{{ handleGetGenderLabel(props.item.gender) || '-' }}</td>
              <td>{{ props.item.weight || '-' }}</td>
              <td><span v-html="handleGetStatusColor(props.item.status)"></span></td>
              <td><span v-html="handleGetStatusColor(props.item.risk_3_months)"></span></td>
              <td>{{ props.item.motivation_q1 || '-' }}</td>
              <td>{{ props.item.motivation_q2 || '-' }}</td>
              <td>{{ handleGetDateWithTime(props.item.timestamp) || '-' }}</td>
              <td>
                <v-btn dark small color="primary" @click="handleShowDetails(props.item.id)">
                  {{ $t('view') }}
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="mt-2">
          <v-pagination
            v-model="pageNumber"
            :total-visible="6"
            :length="pagelength"
            @input="changePage"
          ></v-pagination>
        </div>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import nongtungjaiApi from '@/api/nongtungjai'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import moment from 'moment'
import HeaderTableWithSort from '@/components/elements/HeaderTableWithSort.vue'
import { ORDER_BY } from '@/constants/orderBy.js'
import { DATETIME } from '@/constants/datetime.js'
import Multiselect from 'vue-multiselect'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import AdminMenu from './AdminMenu.vue'

export default {
  components: {
    AdminMenu,
    HeaderTableWithSort,
    Multiselect,
    DatepickerCustomDialog
  },
  data() {
    return {
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      loading: false,
      patientListData: [],
      headers: [
        { text: 'ลำดับที่', value: 'id', customSort: true, sortable: false },
        { text: 'ชื่อจริง', value: 'first_name', customSort: true, sortable: false },
        { text: 'นามสกุล', value: 'last_name', customSort: false, sortable: false },
        { text: 'อายุ', value: 'age', customSort: true, sortable: false },
        { text: 'เพศ', value: 'gender', customSort: true, sortable: false },
        { text: 'น้ำหนัก', value: 'weight', customSort: false, sortable: false },
        { text: 'สถานะความเสี่ยง 7 วัน', value: 'status', customSort: false, sortable: false },
        {
          text: 'สถานะความเสี่ยง 3 เดือน',
          value: 'risk_3_months',
          customSort: false,
          sortable: false
        },
        {
          text: 'คำถามวัดแรงจูงใจ (การปรับเปลี่ยนการดื่ม)',
          value: 'motivation_q1',
          customSort: false,
          sortable: false
        },
        {
          text: 'คำถามวัดแรงจูงใจ (เป้าหมายการเปลี่ยนการดิ่ม)',
          value: 'motivation_q2',
          customSort: false,
          sortable: false
        },
        { text: 'วันที่เริ่มทำประเมิน', value: 'timestamp', customSort: true, sortable: false },
        { text: '', value: '', customSort: false, sortable: false }
      ],
      sortBy: 'id',
      orderBy: ORDER_BY.DESC,
      showAdvancedSearch: false,
      statusOptions: ['ความเสี่ยงต่ำ', 'ความเสี่ยงปานกลาง', 'ความเสี่ยงสูง'],
      genderOptions: [
        {
          label: 'ชาย',
          value: 'male'
        },
        {
          label: 'หญิง',
          value: 'female'
        }
      ],
      filter: {
        first_name: '',
        last_name: '',
        age: '',
        gender: '',
        status: '',
        date_from: '',
        date_to: ''
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  async mounted() {
    await this.handleGetPatientList()
  },
  methods: {
    async handleGetPatientList() {
      const vm = this
      try {
        const response = await vm.getPatientList()
        if (response) {
          vm.patientListData = response.data
          vm.total = response.total
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getPatientList() {
      const vm = this
      const limit = vm.isExport ? vm.total : vm.limit
      let data = {
        page_id: vm.selectedBot.pageid,
        limit: limit,
        offset: vm.offset,
        sort_by: vm.sortBy,
        order_by: vm.orderBy
      }

      Object.entries(vm.filter).forEach(([key, value]) => {
        if (value && Object.keys(value).length > 0) {
          Object.assign(data, { [key]: value.value })
        }
        if (value && value.length) {
          Object.assign(data, { [key]: value.toLowerCase() })
        }
      })

      vm.loading = true
      const response = await nongtungjaiApi.getPatientList({
        config: {
          params: data
        }
      })

      vm.loading = false
      if (response && response.status === 200) {
        return response.data
      } else {
        return null
      }
    },
    async handleExportXlsx() {
      const vm = this
      vm.isExport = true
      const response = await vm.getPatientList()
      const requestData = response.data
      vm.isExport = false

      if (requestData == null) return
      const requests = requestData.map((el) => {
        return {
          id: el.id,
          first_name: el.first_name,
          last_name: el.last_name,
          age: el.age,
          gender: vm.handleGetGenderLabel(el.gender),
          weight: el.weight || '-',
          income: el.income || '-',
          work_status: el.work_status || '-',
          graduation: el.graduation || '-',
          status: el.status ? el.status : '-',
          risk_3_months: el.risk_3_months ? el.risk_3_months : '-',
          motivation_q1: el.motivation_q1 || '-',
          motivation_q2: el.motivation_q2 || '-',
          risk_3_month_check:
            el.motivation_risk_3_month && el.motivation_risk_3_month.length > 0
              ? el.motivation_risk_3_month[0].score_title
              : '-',
          risk_3_months_q1:
            el.motivation_risk_3_month && el.motivation_risk_3_month.length > 0
              ? el.motivation_risk_3_month[1].score_title
              : '-',
          risk_3_months_q2:
            el.motivation_risk_3_month && el.motivation_risk_3_month.length > 0
              ? el.motivation_risk_3_month[2].score_title
              : '-',
          risk_3_months_q3:
            el.motivation_risk_3_month && el.motivation_risk_3_month.length > 0
              ? el.motivation_risk_3_month[3].score_title
              : '-',
          risk_3_months_q4:
            el.motivation_risk_3_month && el.motivation_risk_3_month.length > 0
              ? el.motivation_risk_3_month[4].score_title
              : '-',
          risk_3_months_q5:
            el.motivation_risk_3_month && el.motivation_risk_3_month.length > 0
              ? el.motivation_risk_3_month[5].score_title
              : '-',
          risk_3_months_q6:
            el.motivation_risk_3_month && el.motivation_risk_3_month.length > 0
              ? el.motivation_risk_3_month[6].score_title
              : '-',
          timestamp: vm.handleGetDateFormatted(el.timestamp)
        }
      })

      const heading = [
        [
          'ลำดับที่',
          'ชื่อจริง',
          'นามสกุล',
          'อายุ',
          'เพศ',
          'น้ำหนัก',
          'รายได้',
          'วุฒิการศึกษา',
          'สถานะการทำงาน',
          'สถานะความเสี่ยง 7 วัน',
          'สถานะความเสี่ยง 3 เดือน',
          'คำถามวัดแรงจูงใจ (การปรับเปลี่ยนการดื่ม)',
          'คำถามวัดแรงจูงใจ (เป้าหมายการเปลี่ยนการดิ่ม)',
          'ในชีวิตของคุณ คุณเคยดื่มเครื่องดื่มแอลกอฮอล์บ้างหรือไม่',
          'ในช่วง 3 เดือนที่ผ่านมาคุณดื่มบ่อยแค่ไหน',
          'ในช่วง 3 เดือนที่ผ่านมา คุณเคยรู้สึกอยากดื่ม “อย่างรุนแรง” บ่อยแค่ไหน',
          'ในช่วง 3 เดือนที่ผ่านมา บ่อยแค่ไหนที่การดื่มทำให้เกิดปัญหา สุขภาพ 👨🏽‍🦽ปัญหาครอบครัว การเงิน หรือความสัมพันธ์',
          'ในช่วง 3 เดือนที่ผ่านมา บ่อยแค่ไหน ที่คุณไม่สามารถทำกิจกรรมที่คุณควรทำได้ตามปกติเนื่องจากการดื่มเครื่องดื่ม แอลกอฮอล์',
          'เพื่อน ญาติ หรือคนอื่นๆ เคยแสดงความกังวล หรือตักเตือนคุณ เกี่ยวกับการดื่มของคุณบ้างไหม',
          'คุณเคยพยายามหยุด หรือลดปริมาณการดื่มให้น้อยลง แต่ว่าไม่สำเร็จบ้างหรือไม่ 😫',
          'วันที่เริ่มทำประเมิน'
        ]
      ]

      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, heading)
      XLSX.utils.sheet_add_json(ws, requests, { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `patient-history.xlsx`)
    },
    handleShowDetails(id) {
      this.$router.push(`patient-history/${id}`)
    },
    handleGetDateWithTime(value) {
      try {
        const date = new Date(value)
        return moment(date).format(DATETIME.DATETIME_FORMAT_DISPLAY)
      } catch (error) {
        return ''
      }
    },
    handleGetDateFormatted(value) {
      return value ? moment(value).format(DATETIME.DATE_FORMAT_DISPLAY) : ''
    },
    handleGetGenderLabel(value) {
      return value === 'male' ? 'ชาย' : 'หญิง'
    },
    handleGetStatusColor(status) {
      if (status) {
        let color = ''
        switch (status) {
          case 'ความเสี่ยงต่ำ':
            color = 'success'
            break
          case 'ความเสี่ยงปานกลาง':
            color = 'yellow'
            break
          case 'ความเสี่ยงสูง':
            color = 'error'
            break

          default:
            color = 'primary'
            break
        }
        return `<span class="${color}--text">${status}</span>`
      } else {
        return '-'
      }
    },

    handleSearch() {
      this.reset()
      this.handleCloseSearch()
    },
    handleClearSearch() {
      this.filter = {
        first_name: '',
        last_name: '',
        age: '',
        gender: '',
        status: '',
        date_from: '',
        date_to: ''
      }
      this.reset()
      this.handleCloseSearch()
    },
    handleCloseSearch() {
      this.showAdvancedSearch = false
    },
    changePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit

        vm.handleGetPatientList()
      }
    },
    reset() {
      this.offset = 0
      this.pagetmp = 1
      this.pageNumber = 1
      this.sortBy = 'id'
      this.orderBy = ORDER_BY.DESC
      this.handleGetPatientList()
    },
    handleChangeSort() {
      this.offset = 0
      this.pagetmp = 1
      this.pageNumber = 1
      this.handleGetPatientList()
    },
    allowedDates(val) {
      return moment().diff(val, 'days') > 0
    }
  }
}
</script>

<style lang="scss" scoped>
tr > td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/NongTungJai/PatientHistory.vue